import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import type { AppRegion } from "@core-types/region.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import SkinCardGrid from "../../shared/components/SkinCardGrid";
import type IChampion from "../../shared/models/IChampion.model";

interface SkinChampionSkinsProps {
  champion: IChampion | undefined;
  currentSkinSlug: string | undefined;
  onRegionChange: (region: AppRegion) => void;
}

export const SkinChampionSkins = ({
  champion,
  currentSkinSlug,
  onRegionChange,
}: SkinChampionSkinsProps) => {
  const { t: tChampion } = useAppTranslation("pages.skins.champion");

  if (!champion?.skins?.length) {
    return null;
  }

  return (
    <>
      <SSHeadline
        props={{
          stack: { align: "left", className: "w-full" },
          title: {
            size: 24,
          },
        }}
      >
        <Emoji.Fire />
        <SSWhiteText> {tChampion("allSkins.titlePrefix")} </SSWhiteText>
        <SSLoLGradientText>{champion.name?.toUpperCase()}</SSLoLGradientText>
      </SSHeadline>
      <SkinCardGrid
        onRegionChange={onRegionChange}
        championSlug={champion.slug}
        skins={
          champion?.skins
            .filter((skin_) => skin_.slug !== currentSkinSlug)
            .sort((a, b) => b.accounts.length - a.accounts.length) ?? []
        }
      />
    </>
  );
};
